import React, { useEffect, useState } from "react";
import PT from "prop-types";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import "./live-blog.m.css";

const ShareItem = ({ label, url, id, dataTestId }) => {
  return (
    <div data-testid={dataTestId}>
      <a href={url} target="_blank" rel="noopener noreferrer" data-share-icon={id}>
        <SvgIconHandler type={id} height="32px" width="32px" viewBox="0 0 32 32" />
        <span>{label}</span>
      </a>
    </div>
  );
};
ShareItem.propTypes = {
  label: PT.string,
  dataTestId: PT.string,
};

const ShareMenu = (props) => {
  const { fbUrl, twitterUrl, linkedinUrl, whatsappUrl } = props;
  const [shareMenuOpen, setShareMenuOpen] = useState(false);

  const shareIconSet = [
    {
      id: "share-facebook",
      label: "Facebook",
      url: fbUrl,
    },
    {
      id: "share-x",
      label: "X",
      url: twitterUrl,
    },
    {
      id: "share-whatsapp",
      label: "Whatsapp",
      url: whatsappUrl,
    },
    {
      id: "share-linkedin",
      label: "Linkedin",
      url: linkedinUrl,
    },
  ];

  useEffect(() => {
    const closeShareMenu = () => setShareMenuOpen(false);
    document.body.addEventListener("click", closeShareMenu);

    return () => {
      document.body.removeEventListener("click", closeShareMenu);
    };
  }, []);

  return (
    <span tabIndex={0} styleName="share-menu-container" onClick={() => setShareMenuOpen(true)}>
      <SvgIconHandler type="share-menu" height="32px" width="32px" viewBox="0 0 32 32" />
      {shareMenuOpen && (
        <div styleName="share-menu">
          {shareIconSet.map((iconData, index) => (
            <ShareItem {...iconData} key={iconData.id} dataTestId={`card-share-${index}`} />
          ))}
        </div>
      )}
    </span>
  );
};

export default ShareMenu;
